import { render, staticRenderFns } from "./no-per.vue?vue&type=template&id=07148e9f&"
import script from "./no-per.vue?vue&type=script&lang=js&"
export * from "./no-per.vue?vue&type=script&lang=js&"
import style0 from "./no-per.vue?vue&type=style&index=0&id=07148e9f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports